export const getF2F = state => state.f2f;




/** WEBPACK FOOTER **
 ** ./src/members/state/f2f/selectors.js
 **/